import { render } from "./PaymentMethods.vue?vue&type=template&id=3a636240"
import script from "./PaymentMethods.vue?vue&type=script&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&lang=js"
script.render = render

export default script